export const getLoketBridgeApiUrl = (): string | undefined => process.env.REACT_APP_LOKET_BRIDGE_API_URL
